var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon broadcaster-likes-icon"},_vm._l((3),function(n){return _c('div',{key:n,class:("star star-" + n)},[_c('FaIcon',{attrs:{"icon":"star","fixed-width":""}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }